import type { z } from 'zod';

import { Location } from '../common/enums';
import type { TutorialSchema } from './schemas';

type TutorialField = keyof z.infer<typeof TutorialSchema>;

export const TUTORIAL_LOCATION_ONLINE = 'Online';
export const TUTORIAL_LOCATIONS = [...Object.values(Location), TUTORIAL_LOCATION_ONLINE] as const;

/** The shared Zoom room an online tutorial joins unless it is given its own link. */
export const TUTORIAL_DEFAULT_JOIN_LINK = 'https://us02web.zoom.us/j/4494961628';

const listAttributes = [
  'id',
  'courseId',
  'startDatetime',
  'suffix',
  'duration',
  'hostId',
  'description',
  'joinLink',
  'location',
  'capacity',
  'attendees',
  'linkedTutorialIds',
] as const satisfies readonly TutorialField[];

const getAttributes = [...listAttributes] as const satisfies readonly TutorialField[];

export const teacherUpdateAttributes = [
  'description',
  'joinLink',
  'capacity',
  'location',
] as const satisfies readonly TutorialField[];

export const adminUpdateAttributes = [
  ...teacherUpdateAttributes,
  'hostId',
  'attendees',
] as const satisfies readonly TutorialField[];

export const TutorialAttributes = {
  List: listAttributes,
  Get: getAttributes,
  TeacherUpdate: teacherUpdateAttributes,
  AdminUpdate: adminUpdateAttributes,
};
